module.exports = __webpack_public_path__ + "img/telegram_color.4487a7d.svg";